import React, { useEffect } from "react";
import { Button } from "react-bootstrap";
import apiClient, { apiRoutes } from "../../../hooks/apiClient";

const ExemploFilaAssinatura = () => {
  const { request, data } = apiClient();

  useEffect(() => {
    request(apiRoutes.usuarios.arquivo.fila);
  }, [request]);

  // eslint-disable-next-line no-console
  console.log(data);

  const empty = !data || !data.result.length;

  return (
    <div style={{ backgroundColor: "white", padding: "20px" }}>
      <h1>Arquivos na Fila para Assinatura</h1>
      <br />
      <Button onClick={() => request(apiRoutes.usuarios.arquivo.fila)}>Atualizar</Button>
      <br />
      <br />
      {empty && <h5>Nenhum arquivo na fila</h5>}
      {!empty && (
        <ul>
          {data.result.map((arquivo) => (
            <li>
              <b>{`${arquivo.arquivoNome}:`}</b>
              {arquivo.contextoDescricao}
              <br />
              <br />
              <br />
              <a href={`setrnguard://${arquivo.safePayload}`}>Assinar</a>
              <br />
              <br />
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default ExemploFilaAssinatura;
